(ns ycweb.components.richeditor
  (:require
   [clojure.pprint]
   #?@(:cljs
       [["react-rte" :default RichTextEditor :as react-rte]])
   [rum.core :as rum] ;; https://shadow-cljs.github.io/docs/UsersGuide.html#_using_npm_packages
   [ycweb.components.common :as cmn]
   [ycweb.util.markdown.parse :as markdown]))


#?(:cljs
   (defn rich-text-editor [props]
     (.createElement js/React RichTextEditor props (.-children props))))

(defn html-value [string]
  #?(:cljs
     (react-rte/createValueFromString string "html")
     :clj string))


(defn debounce-input-atom
  [fmt]
  {:will-mount
   (fn [state]
     #?(:clj state
        :cljs
        (let [[val-atom] (:rum/args state)
              local-atom
              (atom (react-rte/createValueFromString (or @val-atom "") fmt))
              component (:rum/react-component state)]
          ;; Setup two-way atom binding
          (add-watch val-atom ::input
            (fn [k r o n]
              (when (and (not= o n) (not= (.toString @local-atom fmt) n))
                (reset! local-atom (react-rte/createValueFromString (or n "") fmt))
                (rum/request-render component))))

          (cmn/debounce-atom local-atom 150
            (fn [n]
              (when (not= @val-atom (.toString n fmt))
                (reset! val-atom
                  (.toString n fmt)))))


          (assoc state ::value local-atom))))})


(rum/defcs htmleditor
  < rum/reactive (debounce-input-atom "html")
  (rum/local (html-value "") ::local)
  [s value-atom & [{:keys [auto-focus]}]]
  (let [val-atom (::value s)]
    #?(:clj
       [:div]

       :cljs
       (rum/adapt-class rich-text-editor
         {:value (rum/react val-atom)
          :autoFocus auto-focus
          :on-change
          (fn [v]
            (reset! val-atom v))}))))


(defn markdown-value [string]
  #?(:cljs
     (react-rte/createValueFromString string "markdown")
     :clj string))

(rum/defcs markdowneditor
  < rum/reactive (debounce-input-atom "markdown")
  [s value-atom & [{:keys [auto-focus]}]]
  (let [val-atom (::value s)]
    #?(:clj
       [:div]

       :cljs
       (rum/adapt-class rich-text-editor
         {:value (rum/react val-atom)
          :auto-focus auto-focus
          :on-change
          (fn [v]
            (reset! val-atom v))}))))

(rum/defcs inline-markdowneditor
  < rum/reactive (rum/local {} ::local) (debounce-input-atom "markdown")
  [s value-atom & [{:keys [auto-focus] :as opts}]]
  (let [val-atom (::value s)
        local-atom (::local s)
        focussed? (cmn/curact local-atom [:focussed?])]
    [:div
     (cond
       focussed?
       #?(:clj
          [:div]

          :cljs
          (rum/adapt-class rich-text-editor
            {:value (rum/react val-atom)
             :auto-focus true
             ;; Causes issues with toolbar et al, just don't hide editor once unhidden.
             #_#_:on-blur #?(:cljs (fn [] (swap! local-atom assoc :focussed? false)) :clj nil)
             :toolbar-style {:borderBottom "none"}
             ;; TODO: need to get tabindex -1, but due to stupid design, the config clobbers the default,
             ;; so have to manually figure out and transcribe default config
             ;; Probably here: https://github.com/sstur/react-rte/blob/8c81622706a5f8856d39497bf33f92a97e9664fc/src/lib/EditorToolbarConfig.js`
             #_:toolbar-config
             #_{:display ["INLINE_STYLE_BUTTONS", "BLOCK_TYPE_BUTTONS", "LINK_BUTTONS", "BLOCK_TYPE_DROPDOWN", "HISTORY_BUTTONS"]
                :INLINE_STYLE_BUTTONS
                [{:label "BOLDISH" :style "BOLD"}]
                :extra-props {:tabIndex -1}}
             :on-change
             (fn [v]
               (reset! val-atom v))}))
       :else
       [:div
        {:on-focus #?(:cljs (fn [] (swap! local-atom assoc :focussed? true)) :clj nil)
         :tab-index 0
         :style
         {:border "1px dashed silver"
          :cursor "text"
          :min-height "30px"
          :padding "10px"}}
        (markdown/parse (rum/react value-atom))])]))
